import React from 'react';
import { Grid, styled } from '@mui/material';
import { ISetupData } from '../models';
import { Text } from 'library';

interface IMicroDepositFormProps {
    setupData: ISetupData;
}

function SetupIntentInfo({ setupData }: IMicroDepositFormProps) {
    return (
        <Grid container>
            <LinkContainer container direction="column" spacing={2}>
                <Text>
                    <b>Est. Arrival Date:</b> {setupData.arrival_date}
                </Text>
                <a href={setupData.verification_url} target="_blank" rel="noreferrer">
                    Verify Link
                </a>
            </LinkContainer>
        </Grid>
    );
}

export default SetupIntentInfo;

const LinkContainer = styled(Grid)({
    padding: 20,
});
